/* eslint-disable import/prefer-default-export */
import _get from 'lodash.get';

// disable eslint rule for this file because we will have more exports later
export const getCellContent = function (column, rowData) {
  const cellData = _get(rowData, column.field);
  return column.render ? column.render({
    column,
    cellData,
    rowData
  }) : cellData;
};